//import './App/services/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {Provider} from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';
import reducers from "./App/reducers";
import {createStore} from "redux";
import LocalStorageState from "./App/services/LocalStorage";
import 'react-datepicker/dist/react-datepicker.css';
import 'react-datetime/css/react-datetime.css';

const local = new LocalStorageState();

const store = createStore(
    reducers,
    local.getState(),
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()//Redux dev tools extension
);

ReactDOM.render((
    <Provider store={store}>
        <BrowserRouter>
            <Route path="/" component={App} />
        </BrowserRouter>
    </Provider>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js